module.exports = __webpack_public_path__ + "img/300.0590b797.jpg";